import React from 'react'

interface RequiredAsteriskProps {
    required: boolean;
}

export const RequiredAsterisk: React.FC<RequiredAsteriskProps> = ({ required }) => {
    if (required) {
        return <span className="ml-1 text-primary-500">*</span>
    }
    return null;
}

interface LabelProps {
    name: string;
    label: string;
    helpText?: string;
    required?: boolean
    insideLabel?: boolean
    className?: string
}

const Label: React.FC<LabelProps> = ({ name, label, helpText, required, insideLabel, className }) => {
    if (insideLabel) {
        return (
            <label htmlFor={name} className={`absolute z-10 flex-shrink-0 px-5 pt-2 text-xs text-gray-600 ${className}`}>
                {label}
                <RequiredAsterisk required={required} />
                {helpText && (<span className="ml-2 text-xs font-normal">{helpText}</span>)}
            </label>
        )
    }

    return (
        <label htmlFor={name} className={`flex-initial mb-1 text-sm font-bold text-black ${className}`}>
            {label}
            <RequiredAsterisk required={required} />
            {helpText && (<span className="ml-2 text-xs font-normal">{helpText}</span>)}
        </label>
    )
}

export default Label